import React, { useEffect, useRef, useState } from "react";
import { BASE_URL } from "../../config";
import { Link } from "react-router-dom";
import { newsPageRouteConverter } from "../../helperFunctions/parseNews";
import "./newSummary.css";
import { highlightedString } from "../../helperFunctions/parseSearch";
import Description from "../description/description";
import { LOGOHUB } from "../images";

const NewSummary = (props) => {
  const { title, description, url, fileName, image, searchText, category } =
    props;

  // Use the URL for the link path (SEO-friendly)
  const articlePath = url ? `/news/${url}` : null;

  const rootRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            io.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={rootRef} className={`fade-card ${visible ? "is-visible" : ""}`}>
      {articlePath && (
        <Link to={articlePath}>
          <div className="a_new">
            <div className="news nRight">
              <div className="post thumbnail">
                <div className="thump_box">
                  <div className="thump_content">
                    <div className="thumb_post">
                      {image && image.imageFile ? (
                        <img
                          alt={image.alt}
                          src={image.imageFile}
                          loading="lazy"
                        />
                      ) : (
                        <img
                          src={LOGOHUB}
                          alt="nbg logo"
                          style={{ objectFit: "contain" }}
                          loading="lazy"
                        />
                      )}
                    </div>
                  </div>
                  <div className="thump_corners top" />
                  <div className="thump_corners bottom" />
                </div>
              </div>
              <div className="post info">
                <div
                  className="pTitle"
                  dangerouslySetInnerHTML={{
                    __html: searchText
                      ? highlightedString(title, searchText)
                      : title,
                  }}
                />

                <div className="pCategory">{category ? category : null}</div>
                <div className="pDescription">
                  <Description query={searchText} description={description} />
                </div>
              </div>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
};

export default NewSummary;
